import { useMemo } from "react";
import CodeMirror, { Extension } from "@uiw/react-codemirror";
import { javascript } from "@codemirror/lang-javascript";
import { python } from "@codemirror/lang-python";
import { java } from "@codemirror/lang-java";
import { cpp } from "@codemirror/lang-cpp";
import { php } from "@codemirror/lang-php";
import { StreamLanguage } from "@codemirror/language";
import { csharp } from "@codemirror/legacy-modes/mode/clike";
import { CodingAnswer, CodingLanguage } from "@verity/api-client/types";
import styles from "./QuestionAnswer.module.css";
import { AnswerStatusChip } from "./shared";
import type { QuizResponseResult } from "../hooks/verityAssessmentResultHelper.js";

// Duplicated from CodingQuestion.tsx to avoid a cross-feature import between take-assessment and results.
const LANGUAGE_EXTENSIONS: Record<CodingLanguage, Extension> = {
	javascript: javascript(),
	python: python(),
	java: java(),
	cpp: cpp(),
	c: cpp(),
	php: php(),
	csharp: StreamLanguage.define(csharp),
};

/** Manually graded — no correctness check, just read-only syntax-highlighted display. */
export function CodingAnswerView({ response }: { response: QuizResponseResult | undefined }) {
	const userAnswer = response?.answer as CodingAnswer | undefined;
	const language = userAnswer?.language ?? "javascript";
	const extensions = useMemo(() => [LANGUAGE_EXTENSIONS[language]], [language]);

	if (response?.isAnswered !== true || !userAnswer?.code.trim()) {
		return <AnswerStatusChip userText="" isCorrect={null} style={{ margin: "0" }} />;
	}
	return (
		<div className={styles.codingAnswerWrapper}>
			<CodeMirror
				value={userAnswer.code}
				theme="light"
				extensions={extensions}
				editable={false}
				basicSetup={{ autocompletion: false, highlightActiveLine: false, highlightActiveLineGutter: false }}
				className={styles.codingAnswerCode}
			/>
		</div>
	);
}
